<template>
  <div v-if="loading" class="text-center py-5">
    <div class="spinner-border text-purple spinner-border-sm" role="status"></div>
  </div>
  <apexchart
    v-else
    type="bar"
    height="350"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import api from '../../services/api';

const DIAS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export default {
  name: 'ThisWeeksSalesPurchasesChart',
  data() {
    return {
      loading: true,
      totalesPorDia: new Array(7).fill(0),
      categorias: DIAS,
    };
  },
  computed: {
    series() {
      return [{ name: 'Ventas (S/)', data: this.totalesPorDia }];
    },
    chartOptions() {
      return {
        chart: { type: 'bar', height: 350, toolbar: { show: false } },
        colors: ['#4F46E5'],
        plotOptions: { bar: { horizontal: false, columnWidth: '55%', borderRadius: 4 } },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 1, colors: ['transparent'] },
        xaxis: { categories: this.categorias },
        yaxis: { title: { text: 'S/' } },
        grid: { show: true, borderColor: '#EEF3FA' },
        legend: { show: false },
        tooltip: { y: { formatter: v => 'S/ ' + Number(v).toFixed(2) } },
      };
    },
  },
  async mounted() {
    try {
      const res = await api.get('/dashboard');
      const semana = res.data.data.ventasSemana || [];

      // lunes de esta semana
      const lunes = new Date();
      lunes.setHours(0, 0, 0, 0);
      lunes.setDate(lunes.getDate() - ((lunes.getDay() + 6) % 7));

      const totales = new Array(7).fill(0);
      const cats = [];
      for (let i = 0; i < 7; i++) {
        const d = new Date(lunes);
        d.setDate(lunes.getDate() + i);
        const iso = d.toISOString().slice(0, 10);
        cats.push(DIAS[i]);
        const found = semana.find(r => r.dia && r.dia.slice(0, 10) === iso);
        if (found) totales[i] = parseFloat(found.total);
      }
      this.totalesPorDia = totales;
      this.categorias = cats;
    } catch (e) {
      console.error('SemanaChart', e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
